import { SiteMeta } from '@src/types/SiteMeta';
import { CircleClass, InventoryStatus, RunMode } from '@src/types/UnitItem';

const IDLE_STATUSES = new Set([InventoryStatus.IDLE, InventoryStatus.READY]);

const RUNNING_STATUSES = new Set([
  InventoryStatus.RUN_PQ,
  InventoryStatus.RUN_UF,
  InventoryStatus.FORMING,
]);

const TRANSITIONAL_STATUSES = new Set([
  InventoryStatus.CONNECTING,
  InventoryStatus.DISCONNECTING,
  InventoryStatus.STARTING,
  InventoryStatus.STOPPING,
  InventoryStatus.STANDBY,
  InventoryStatus.GOING_TO_STANDBY,
]);

const isThresholdLimited = (
  allowedMaxP: number,
  allowedMinP: number,
  siteMeta: SiteMeta,
): boolean =>
  +allowedMaxP < +siteMeta.Thresh_UnitMaxP ||
  +allowedMinP > +siteMeta.Thresh_UnitMinP;

export const getCircleClass = (
  invStatus: InventoryStatus | undefined,
  runMode: RunMode | undefined,
  allowedMaxP: number,
  allowedMinP: number,
  siteMeta: SiteMeta,
): CircleClass => {
  if (!invStatus || !runMode || IDLE_STATUSES.has(invStatus)) {
    return CircleClass.NONE;
  }

  if (invStatus === InventoryStatus.OFF) {
    return CircleClass.GRAY;
  }

  if (TRANSITIONAL_STATUSES.has(invStatus)) {
    return CircleClass.YELLOW;
  }

  if (
    invStatus.includes(InventoryStatus.FAULT) ||
    invStatus.includes(InventoryStatus.COMMS)
  ) {
    return runMode === RunMode.AUTO || runMode === RunMode.MANUAL
      ? CircleClass.RED
      : CircleClass.NONE;
  }

  if (RUNNING_STATUSES.has(invStatus)) {
    const isLimited = isThresholdLimited(allowedMaxP, allowedMinP, siteMeta);
    if (runMode === RunMode.AUTO) {
      return isLimited ? CircleClass.BLUE_A : CircleClass.GREEN_A;
    }
    if (invStatus !== InventoryStatus.FORMING) {
      return isLimited ? CircleClass.BLUE : CircleClass.GREEN;
    }
  }

  return CircleClass.NONE;
};
